import { apiClients } from '@app/services/api/clients'
import { getApiClient } from '@app/utils/apiUtils'

export default (country, dpId, shipperId, startDate, endDate) => {
  const client = getApiClient(apiClients, country)
  const url = `1.0/dps/${dpId}/shipper-trend?shipper_id=${shipperId}&start_date=${startDate}&end_date=${endDate}`
  return client.get(url)
}
